import { render } from "./Landingpage.vue?vue&type=template&id=17e70734&scoped=true&bindings={}"
import script from "./Landingpage.vue?vue&type=script&lang=js"
export * from "./Landingpage.vue?vue&type=script&lang=js"

import "./Landingpage.vue?vue&type=style&index=0&id=17e70734&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17e70734"

export default script